module.exports = __webpack_public_path__ + "static/img/logo_fbt_01_v3.01dc1474.png";